import SpeechBubble from './SpeechBubble'

export type { SpeechBubbleProps } from './SpeechBubble.types'
export default SpeechBubble
